<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <br><br>

    <v-layout row wrap>
      <v-flex xs12 md6 >
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Fornecedores Cadastrados no SIMPAS</strong>
          </p>
        </div>
        <br/>
        <canvas id="languagePie"></canvas>     
        <br/>
      </v-flex>
      
      <v-flex xs12 md6 >
        <div class="tituloBox p-b-10 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Cadastros por Tipo no ComprasNet</strong>
          </p>
        </div>         
        <div style="height: 50px;">
          <v-select style="height: 20%; width:20%; float: right; position: relative;" item-end      
                v-model="selectAnoPesquisa"        
                :items="anosPesquisa"  
                dense                    
            ></v-select>   
        </div>          
        <canvas id="tipoSolicitacaoStackedBar"></canvas>
        <br/>
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilHabilitadorMaster()">
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Fornecedores Cadastrados por Categoria</strong>
          </p>
        </div>
        <canvas id="categoriaCadastroPie"></canvas>     
      </v-flex>
 
      <v-flex xs12 md6 >
        <div class="tituloBox p-b-10 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Top 10 Fornecedores Com Mais Participações Em PCEs</strong>
          </p>
        </div>
        <br/>
        <canvas id="topTenBar"></canvas>     
      </v-flex>

      <v-flex xs12 md6 v-if="$verificaPerfilHabilitadorMaster()" >
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <p class="text-info font-size-18">
            <strong>Quantitativo de solicitações analisadas pelos analistas</strong>
          </p>
        </div>
       
            <v-layout row wrap>
          <b>período:</b>         

             <v-flex xs12 md4>
              <datePicker
                v-model="dataIni"
                :dataDefault="dataIni"
                v-mask="maskData"
                :limitarData="true"                
                :label="'Data Inicial'"                
                validate-on-blur                
                persistent-hint               
              />
            </v-flex>
           
                   <b>a</b>  
                      <v-flex xs12 md4>
              <datePicker
                v-model="dataFim"
                :dataDefault="dataFim"
                v-mask="maskData"
                :limitarData="true"                
                :label="'Data Final'"                
                validate-on-blur                
                persistent-hint               
              />
            </v-flex>
            
              <v-btn style="width: 20px; align-self:center;"
                        text
                        color="primary"
                        @click="montarDashboardQuantitativoSolicitacoes(dataIni,dataFim)"
                    >
                        Pesquisar
                    </v-btn>
                  
                    </v-layout>
                
        <canvas id="topAnalistaBar"></canvas>     
      </v-flex>
    </v-layout>

  </div>
</template>
<script>
import util from "../../../plugins/util";
import Chart from 'chart.js'
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */

export default {
  name: "dashboard",
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  },
   data() {//Declaracao de variaveis
    return {
      dashTipoCadastroSimpas: [],
      anosPesquisa: [],
      selectAnoPesquisa: null,
      dashCategoriaCadastroSimpas: [],
      dataIni: null,
      dataFim: null,
    };
   },
   mixins: [util],
   watch :{
     'selectAnoPesquisa': function(){
        this.montarDashboardTipoSolicitacao();
     },
     date (val) {
            this.dataIni = this.formatDate(this.dataIni)
            this.dataIni = this.formatDate(this.dataFim)

        }
   },
  created() /*Metodo de start do componente*/{
    this.montarDashboardTipoCadastroSimpas();
    this.gerarAnos();
    this.montarDashboardCategoria();
    this.$store.commit("setAba", {
        abaAtiva: "tab-dados"
      });
  },
  mounted() {
     this.montarDashboardTipoSolicitacao();
     this.montarDashboardTopTen();
     this.montarDashboardQuantitativoSolicitacoes("","");
  },

  methods: {//Declaracao de todos os metodos
    gerarAnos(){
      var d = new Date();
      var anoCorrente = d.getFullYear();
      this.selectAnoPesquisa = anoCorrente;
      for(var ano=2019; ano<=anoCorrente ; ano++){
        this.anosPesquisa.push(ano);
      }
    },    
    /* método que gera gráfico de tipos de fornecedores cadastrados no SIMPAS
      (CRC, CRS, CREDENCIAMENTO) */
    montarDashboardTipoCadastroSimpas(){
       this.$mostrarPreload(); /*Exibir o PreLoad*/
          fornecedorService.carregarDashboard(1).then(response => { /*resposta do servico*/
          this.dashTipoCadastroSimpas = response.data

             this.$nextTick(() => {
              var pieChartCanvas = document.getElementById('languagePie').getContext('2d')
              var pieConfig = {
                type: 'pie',
                data: {
                  labels: [this.dashTipoCadastroSimpas.legendas.crc,this.dashTipoCadastroSimpas.legendas.crs,this.dashTipoCadastroSimpas.legendas.credenciamento],
                  datasets: [{
                    data: [this.dashTipoCadastroSimpas.percentuais.crc,this.dashTipoCadastroSimpas.percentuais.crs,this.dashTipoCadastroSimpas.percentuais.credenciamento],
                    backgroundColor: ['#CD3333', 'green', '#4876FF'],
                    hoverBackgroundColor: ['#CD3333', 'green', '#4876FF']
                  }]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function (tooltipItem, data) {
                              return data.labels[tooltipItem.index];
                          }
                      },
                      enabled: true,
                  },
                  responsive: true,
                  maintainAspectRatio: !this.isMobile,
                  legend: {
                    position: 'right',
                    display: true,
                  },
                }
              }
              new Chart(pieChartCanvas, pieConfig)

            })

          this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },

    /* Método que gera gráfico de tipos de solicitação
      (Novo, Alteração) */
    montarDashboardTipoSolicitacao(){
       this.$mostrarPreload(); /*Exibir o PreLoad*/
       fornecedorService.consultarTipoSolicitacaoDashboard(this.selectAnoPesquisa).then(response => { /*resposta do servico*/
          var stackedBarChart = document.getElementById('tipoSolicitacaoStackedBar');
          this.$nextTick(() => {
           
            var tipoNovo = response.data.quantidade.novo;
            var tipoAlteracao = response.data.quantidade.alteracao;
            var labelMeses = response.data.legendas;
            var myChart = new Chart(stackedBarChart, {
                type: 'bar',
                data: {
                  labels: labelMeses,
                  datasets: [
                    {
                      label: 'Novo',
                      data: tipoNovo,
                      backgroundColor: '#CD3333',
                    },
                    {
                      label: 'Alteração',
                      data: tipoAlteracao,
                      backgroundColor: '#4876FF',
                    }
                  ]
                },
                options: {
                  scales: {
                    xAxes: [{ stacked: true }],
                    yAxes: [{ stacked: true }]
                  },
                  responsive: true,
                }
              });
          });
       });
    },

     montarDashboardQuantitativoSolicitacoes(dataIni,dataFim){
       this.$mostrarPreload(); /*Exibir o PreLoad*/
        fornecedorService.consultarQuantitativoSolicitacoesDashboard(dataIni,dataFim).then(response => { /*resposta do servico*/
            this.dashCategoriaCadastroSimpas = response.data
               
            var tipoNovo = response.data.quantidadeInscricao;
            var tipoAlteracao =  response.data.quantidadeAlteracao;

            this.$nextTick(() => {             
              var horizontalBarChart = document.getElementById('topAnalistaBar');
              
              let data = [  {
                              label: 'Quantitativo de Solicitações Analisadas no Dia (Solicitação de Alteração) ',
                              backgroundColor: '#4876FF',
                              data: tipoAlteracao
                            },
                            {
                              label: 'Quantitativo de Solicitações Analisadas no Dia (Inscrição)',
                              backgroundColor: '#CD3333',
                              data: tipoNovo
                            }
                          ];
              if (window.grafica) {
                window.grafica.clear();
                window.grafica.destroy();
              }
              window.grafica = new Chart(horizontalBarChart, {
                type: 'horizontalBar',
                data: {
                  labels: response.data.legendas,
                  datasets: data
                },
                options: {
                  scales: {
                    xAxes: [{ stacked: true }],
                    yAxes: [{ stacked: true }]
                  },
                  tooltips: {
                    enabled: true,
                    mode: 'label',
                    callbacks: {
                      title: function(tooltipItems, data) {
                        var idx = tooltipItems[0].index;
                        return data.labels[idx];
                      },
                      label: function(tooltipItems, data) {
                        return tooltipItems.xLabel;
                      }
                    }
                  },
                }
              });

          })

        this.$removePreload(); /*Ocultar o PreLoad*/
      });          
       
    },

    /* Método que gera gráfico de fornecedores cadastrados por categoria
      (NO, MEI, ME, EPP, ES, ES, AF) */
    montarDashboardCategoria(){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
          fornecedorService.carregarDashboard(3).then(response => { /*resposta do servico*/
          this.dashCategoriaCadastroSimpas = response.data

            this.$nextTick(() => {
              var pieChartCanvas = document.getElementById('categoriaCadastroPie').getContext('2d')
              var pieConfig = {
                type: 'pie',
                data: {
                  labels: [this.dashCategoriaCadastroSimpas.legendas.no,
                  this.dashCategoriaCadastroSimpas.legendas.mei,
                  this.dashCategoriaCadastroSimpas.legendas.me,
                  this.dashCategoriaCadastroSimpas.legendas.epp,
                  this.dashCategoriaCadastroSimpas.legendas.es,
                  this.dashCategoriaCadastroSimpas.legendas.ec,
                  this.dashCategoriaCadastroSimpas.legendas.af],
                  datasets: [{
                    data: [this.dashCategoriaCadastroSimpas.percentuais.no,
                    this.dashCategoriaCadastroSimpas.percentuais.mei,
                    this.dashCategoriaCadastroSimpas.percentuais.me,
                    this.dashCategoriaCadastroSimpas.percentuais.epp,
                    this.dashCategoriaCadastroSimpas.percentuais.es,
                    this.dashCategoriaCadastroSimpas.percentuais.ec,
                    this.dashCategoriaCadastroSimpas.percentuais.af],
                    backgroundColor: ['#CD3333', 'silver', '#4876FF', 'green', 'orange', 'purple', 'pink'],
                    hoverBackgroundColor: ['#CD3333', 'silver', '#4876FF', 'green', 'orange', 'purple', 'pink']
                  }]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function (tooltipItem, data) {
                              return data.labels[tooltipItem.index];
                          }
                      },
                      enabled: true,
                  },
                  responsive: true,
                  maintainAspectRatio: !this.isMobile,
                  legend: {
                    position: 'right',
                    display: true,
                  },
                }
              }
              new Chart(pieChartCanvas, pieConfig)

            })

          this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },

    /* Método que gera gráfico de fornecedorescom mais
    participações em PCEs - Top 10 */
     montarDashboardTopTen(){
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        fornecedorService.carregarDashboard(4).then(response => { /*resposta do servico*/
            this.dashCategoriaCadastroSimpas = response.data

            this.$nextTick(() => {
              var horizontalBarChart = document.getElementById('topTenBar');
              let data = [{
                              label: 'Participações em PCEs',
                              backgroundColor: '#3366ff',
                              data: response.data.quantidade
                            }
                          ];

              let myChart = new Chart(horizontalBarChart, {
                type: 'horizontalBar',
                data: {
                  labels: response.data.legendas,
                  datasets: data
                },
                options: {
                  scales: {
                    xAxes: [{
                      ticks: {
                        beginAtZero: true
                      }
                    }],
                    yAxes: [{
                      ticks: {
                        callback: function(value) {
                          if (value.length > 20) {
                            return value.substr(0, 20) + '...'; //truncate
                          } else {
                            return value
                          }
                        },
                      }
                    }]
                  },
                  tooltips: {
                    enabled: true,
                    mode: 'label',
                    callbacks: {
                      title: function(tooltipItems, data) {
                        var idx = tooltipItems[0].index;
                        return data.labels[idx];
                      },
                      label: function(tooltipItems, data) {
                        return tooltipItems.xLabel;
                      }
                    }
                  },
                }
              });

          })

        this.$removePreload(); /*Ocultar o PreLoad*/
      });
    }
  }
};
</script>
<style scoped>
b{
  align-self:center;
}
</style>
